<template>
  <div class="modal to-top" :class="className">
      <div class="modal-background"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p v-if="usage == false" class="modal-card-title">Are you sure?</p>
            <p v-else class="modal-card-title">Tag has already been used.</p>
          </header>
          <footer class="modal-card-foot has-text-centered">
            <button v-if="usage == false" @click="save" class="is-primary button">{{ $t("Yes") }}</button>
            <button @click="callback" class="is-info button">{{ $t("Cancel") }}</button>
          </footer>
      </div>
  </div>
</template>

<script>
export default {
  name: "DeregisterTagModal",
  props: {
    tagId: String,
    usage: Boolean,
    className: String,
    callback: Function
  },
  methods:
  {
    async save()
    {
        let response;

        try
        {
            response = await this.$http.post(`/Tags/DeregisterTag?tagId=${this.tagId}`);

            if(response.data.success != true)
            {
                alert("Something went wrong, please try again or contact customer service.");
                this.callback();
            }

            else
            {
              alert("Tag successfully de-registered.") 
              this.callback();
            }
        }

        catch(error)
        {
// eslint-disable-next-line
            console.log(error);
        }
    }
  }
};
</script>